module.exports = __webpack_public_path__ + "static/media/traffic-alert.b19eb72e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peterpan/traffic-alert.svg
// module id = 819
// module chunks = 0